import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Chip,
    IconButton,
    Modal, Slide,
    Typography
} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import {RootState} from "../../../store"
import React, {FormEvent, Fragment, useEffect, useState} from "react"
import {
    fieldingAssignFtrAccept,
    fieldingAssignFtrDecline,
    fieldingClearNotification, fieldingConfirmAssigned,
    fieldingGetNotification,
    fieldingReadNotification
} from "../../fielding/fielding.api"
import {InterfaceFieldingNotification} from "../../fielding/fielding.interface"
import {ArrowBack} from "@mui/icons-material"
import {useNavigate} from "react-router-dom"
import CustomModal from "../../../shared/customModal/CustomModal"
import NotificationNoteReply from "./NotificationNoteReply"
import notificationSuccess from "../../../shared/notificationSuccess"
import CustomLoading from "../../../shared/CustomLoading"
import ButtonOutlined from "../../../shared/ButtonOutlined"
import hot from "../../../assets/images/hot.png"
import AccountPasswordValidation from "../../account/component/AccountPasswordValidation";
import {deleteExpense, getPersonalExpense} from "../../expense/expense.api";
import {resetDataDetail} from "../../expense/expense.reducer";
import FieldingWorkDateConfirmation from "../../fielding/component/FieldingWorkDateConfirmation";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import moment from "moment"
import notificationError from "../../../shared/notificationError";
import Swal from "sweetalert2";

export default function NotificationSlider(props: { open: boolean, onClose: () => void }) {
    const dispatch = useDispatch<any>()
    const navigate = useNavigate()

    const {dataNotificationList} = useSelector((state: RootState) => state.fielding)

    const [noteIdSelected, setNoteidSelected] = useState("")

    const [modalWorkDate, setModalWorkDate] = useState(false)
    const [fieldingRequestId, setFieldingRequestId] = useState("")
    const [requestedStartDate, setRequestedStartDate] = useState("")
    const [requestedEndDate, setRequestedEndDate] = useState("")


    useEffect(() => {
        dispatch(fieldingGetNotification())
        dispatch(fieldingReadNotification())
    }, [])

    const isShowActions = (data: InterfaceFieldingNotification) => {
        return Boolean(data.isFirstToReceive || data.fieldingRequestNoteId)
    }

    const handleAccept = (fieldingRequestId: string) => {
        dispatch(fieldingAssignFtrAccept(fieldingRequestId))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    notificationSuccess("")
                    dispatch(fieldingGetNotification())
                }
            })
    }

    const handleDecline = (fieldingRequestId: string) => {
        dispatch(fieldingAssignFtrDecline(fieldingRequestId))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    notificationSuccess("")
                    dispatch(fieldingGetNotification())
                }
            })
    }

    const handleClear = () => {
        dispatch(fieldingClearNotification())
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    dispatch(fieldingGetNotification())
                }
            })
    }

    var lastDate = ""

    const onClose = () => {
        setModalWorkDate(false)
        setFieldingRequestId("")
        setRequestedStartDate("")
        setRequestedEndDate("")
    }

    const onAssignDeclined = (id: string) => {
        Swal.fire({
            icon: 'question',
            title: 'Are you sure want to decline this assign?',
            showCancelButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(fieldingConfirmAssigned({
                    token: '',
                    acceptedStartDate: moment().toISOString(),
                    acceptedEndDate: moment().toISOString(),
                    id: id,
                    isAccepted: false,
                }))
                    .unwrap()
                    .then((response: any) => {
                        if (response.status === 200) {
                            notificationSuccess({})
                            dispatch(fieldingGetNotification())
                        } else {
                            notificationError(response)
                        }
                    })
            }
        })
    }

    return (
        <>
            <CustomModal
                open={modalWorkDate}
                onClose={() => {
                    onClose()
                }}
                title='Work Date Confirmation'
                size='sm'
                component={
                    <FieldingWorkDateConfirmation
                        fieldingRequestId={fieldingRequestId}
                        requestedStartDate={requestedStartDate}
                        requestedEndDate={requestedEndDate}
                        onClose={() => {
                            onClose()
                        }}
                        onValidate={() => {
                            dispatch(fieldingGetNotification())
                            onClose()
                        }}
                    />
                }
            />

            <Modal open={props.open} onClose={props.onClose}
                   sx={{display: "flex", justifyContent: "flex-end", zIndex: 10000}}>
                <Slide direction="left" in={props.open}>
                    <Box height={"100vh"} overflow={"auto"} bgcolor={"#e5e5e5"}>
                        <CustomLoading/>
                        <CustomModal
                            open={Boolean(noteIdSelected)}
                            onClose={() => setNoteidSelected("")}
                            title="Reply Note"
                            size="sm"
                            component={
                                <NotificationNoteReply
                                    noteId={noteIdSelected}
                                    onSubmit={() => dispatch(fieldingGetNotification())}
                                />
                            }
                        />
                        <Box bgcolor={"#ffffff"} borderBottom={'2px solid #eaeaea'} color={"black"} display={"flex"}
                             alignItems={"center"} padding={2}>
                            <IconButton onClick={props.onClose}>
                                <ArrowBack sx={{color: "black"}}/>
                            </IconButton>
                            <Typography>Notification</Typography>
                        </Box>
                        <Box padding={3} bgcolor={"#ffffff"}>
                            <Box display={"flex"} justifyContent={"flex-end"}>
                                <Button variant="contained" onClick={handleClear}>
                                    Clear All Notification
                                </Button>
                            </Box>
                            {dataNotificationList.map((data, dataIndex) => {
                                const isShowDate = lastDate !== data.assignedDate
                                lastDate = data.assignedDate
                                return (
                                    <Fragment key={dataIndex}>
                                        {isShowDate && (
                                            <Typography variant="body1" padding={2}>
                                                {data.assignedDate}
                                            </Typography>
                                        )}
                                        <Card sx={{
                                            marginBottom: 1,
                                            backgroundColor: data.category === "AssignConfirmation" ? "#eef0f3" : "#ffffff",
                                            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)"
                                        }}>
                                            <CardHeader
                                                title={(
                                                    <Box gap={1} alignItems={"center"}>
                                                        <Box display={"flex"} mb={1} gap={1} alignItems={"center"}>
                                                            <Typography variant="h5"
                                                                        color={data.isHotJob ? "red" : undefined}>{data.project}</Typography>
                                                        </Box>
                                                        <Box display={"flex"} gap={1} alignItems={"center"}>
                                                            <Typography variant="h6">{data.fieldingRequest}</Typography>
                                                            {data.isHotJob && (
                                                                <img src={hot} alt="hot"
                                                                     style={{width: "20px", height: "20px"}}/>
                                                            )}
                                                            {/*<Typography variant="h5">-</Typography>*/}

                                                            {
                                                                data.isReactivated && (
                                                                    <Chip label={`REJECTED`}
                                                                          sx={{
                                                                              backgroundColor: '#8b0000',
                                                                              color: '#ffffff',
                                                                              fontWeight: 'bold',
                                                                              ml: 2,
                                                                              mr: 1
                                                                          }}/>
                                                                )
                                                            }
                                                        </Box>
                                                    </Box>
                                                )}
                                                action={
                                                    <div>
                                            <span style={{fontSize: "10px", paddingLeft: 10}}>
                                                {data.assignedTime}
                                            </span>
                                                    </div>
                                                }
                                            />
                                            {(data.notes !== null) && (
                                                <CardContent>
                                                    <Typography>from : {data.from}</Typography>
                                                    <Typography>note : {data.notes}</Typography>
                                                </CardContent>
                                            )}
                                            {data.category === "AssignConfirmation" && (
                                                <CardContent>
                                                    <Box display={"flex"} mb={1} gap={1} alignItems={"center"}>
                                                        <CalendarMonthIcon/>
                                                        <Typography sx={{fontWeight: 'bold'}}>Recommended work date
                                                            : </Typography>
                                                    </Box>

                                                    <Typography>{moment(data.fieldingRequestRequestedStartDate).format('MM/DD/YYYY')} - {moment(data.fieldingRequestRequestedDate).format('MM/DD/YYYY')}</Typography>
                                                </CardContent>
                                            )}
                                            {Boolean(data.fieldingRequestNoteId) && (
                                                <CardContent>
                                                    <Typography variant="h6">{data.content}</Typography>
                                                    from : {data.from}
                                                </CardContent>
                                            )}
                                            {
                                                data.category === "AssignConfirmation" && (
                                                    <CardActions sx={{display: "flex", flexDirection: "row"}}>
                                                        <Box display={"flex"} flexGrow={1} justifyContent={"flex-end"}
                                                             gap={1}>
                                                            <Fragment>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="secondary"
                                                                    sx={{
                                                                        borderColor: '#8e8e8e',
                                                                        color: '#8e8e8e'
                                                                    }}
                                                                    onClick={() => {
                                                                        onAssignDeclined(data.assignFielderConfirmationId)
                                                                    }}
                                                                >
                                                                    Decline
                                                                </Button>
                                                                <ButtonOutlined
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => {
                                                                        setModalWorkDate(true)
                                                                        setFieldingRequestId(data.assignFielderConfirmationId)
                                                                        setRequestedStartDate(data.fieldingRequestRequestedStartDate)
                                                                        setRequestedEndDate(data.fieldingRequestRequestedDate)
                                                                    }}
                                                                >
                                                                    Approve
                                                                </ButtonOutlined>
                                                            </Fragment>
                                                        </Box>
                                                    </CardActions>
                                                )
                                            }
                                            {isShowActions(data) && (
                                                <CardActions sx={{display: "flex", flexDirection: "row"}}>
                                                    <Box display={"flex"} flexGrow={1} justifyContent={"flex-end"}
                                                         gap={1}>
                                                        {data.isFirstToReceive && (
                                                            <Fragment>
                                                                <Button
                                                                    variant="contained"
                                                                    color="error"
                                                                    onClick={() => handleDecline(data.fieldingRequestId)}
                                                                >
                                                                    Decline
                                                                </Button>
                                                                <ButtonOutlined
                                                                    color="success"
                                                                    onClick={() => handleAccept(data.fieldingRequestId)}
                                                                >
                                                                    Accept
                                                                </ButtonOutlined>
                                                                <Button
                                                                    variant="contained"
                                                                    // color="success"
                                                                    onClick={() =>
                                                                        navigate(
                                                                            `/fielding/detail?preview=true&id=${data.fieldingRequestId}`
                                                                        )
                                                                    }
                                                                >
                                                                    View On Map
                                                                </Button>
                                                            </Fragment>
                                                        )}
                                                        {Boolean(data.fieldingRequestNoteId) && (
                                                            <ButtonOutlined
                                                                onClick={() => setNoteidSelected(data.fieldingRequestNoteId)}
                                                            >
                                                                Reply
                                                            </ButtonOutlined>
                                                        )}
                                                    </Box>
                                                </CardActions>
                                            )}
                                        </Card>
                                    </Fragment>
                                )
                            })}
                        </Box>
                    </Box>
                </Slide>
            </Modal>
        </>
    )
}
